<template>
  <v-card
    color="grey lighten-4"
    class="black--text"
    style="margin: 16px; position: relative"
  >
    <div style="position: absolute; right: 0; top: 0; padding: 8px">
      <v-menu offset-y>
        <v-btn
          small
          :color="person.status === 'Completed' ? 'green' : 'red'"
          flat
          slot="activator"
        >
          {{ person.status }}
        </v-btn>
        <v-card>
          <v-list>
            <v-list-tile @click="setStatus('Completed')">
              <v-list-tile-title>Completos</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="setStatus('Missing')">
              <v-list-tile-title>Faltan</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-btn slot="activator" small flat color="red">DELETE</v-btn>
        <v-card>
          <v-card-title class="headline">Borrar esta información</v-card-title>
          <v-card-text
            >¿Estás seguro de que quieres eliminar esta información? Esta acción
            es irreversible y no se borrarán los datos de la
            reserva</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="deleteItem">Borrar</v-btn>
            <v-btn color="grey darken-1" flat @click="dialog = false"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 hidden-md-and-up> </v-flex>
        <v-flex xs12>
          <h3 style="padding-top: 8px" class="title">
            {{ person.name + " " + person.lastname }} - {{ person.id }}
          </h3>
        </v-flex>
        <v-flex xs6 md2>
          <div class="caption" style="opacity: 0.7">Unidad</div>
          <div>{{ person.unidad ? person.unidad : person.rama }}</div>
        </v-flex>
        <v-flex xs6 md2>
          <div class="caption" style="opacity: 0.7">Fecha de nacimiento</div>
          <div>{{ person.birthday }}</div>
        </v-flex>
        <v-flex xs6 md2>
          <div class="caption" style="opacity: 0.7">Dias</div>
          <div v-if="person.days.length == 16">Todos</div>
          <div v-else style="color: red">
            {{ person.days.join(" ") }}
          </div>
        </v-flex>
        <v-flex xs6 md2>
          <div class="caption" style="opacity: 0.7">Bus</div>
          <div v-if="person.days.length == 2">Ambas</div>
          <div v-else style="color: red">
            {{ person.bus.join(" ") }}
          </div>
        </v-flex>
        <v-flex xs6 md2>
          <div class="caption" style="opacity: 0.7">Peso</div>
          <div>{{ person.peso }}</div>
        </v-flex>
        <v-flex xs6 md2> </v-flex>
        <v-flex xs12 md12>
          <div style="display: inline-block">
            <div class="caption" style="opacity: 0.7">Documentos</div>
            <v-btn
              outline
              v-if="
                person.seguridad_social && person.seguridad_social.length > 0
              "
              @click="openFile(person.seguridad_social[0])"
              >Seguridad Social</v-btn
            >
            <v-icon
              v-if="
                person.seguridad_social && person.seguridad_social.length > 0
              "
              @click="
                $router.push({
                  name: 'resubir',
                  query: {
                    idPerson: person.id,
                    type: 'seguridad_social',
                  },
                })
              "
              >edit</v-icon
            >

            <v-btn
              outline
              v-if="
                person.cartilla_vacunacion &&
                person.cartilla_vacunacion.length > 0
              "
              @click="openFile(person.cartilla_vacunacion[0])"
              >Cartilla Vacunación</v-btn
            >
            <v-icon
              v-if="
                person.cartilla_vacunacion &&
                person.cartilla_vacunacion.length > 0
              "
              @click="
                $router.push({
                  name: 'resubir',
                  query: {
                    idPerson: person.id,
                    type: 'vacunas',
                  },
                })
              "
              >edit</v-icon
            >

            <v-btn
              outline
              v-if="person.autorizacion && person.autorizacion.length > 0"
              @click="openFile(person.autorizacion[0])"
              >Autorización</v-btn
            >
            <v-icon
              v-if="person.autorizacion && person.autorizacion.length"
              @click="
                $router.push({
                  name: 'resubir',
                  query: {
                    idPerson: person.id,
                    type: 'autorizacion',
                  },
                })
              "
              >edit</v-icon
            >
          </div>
          <div
            style="display: inline-block; padding-left: 16px"
            v-if="person.docs && person.docs.length > 0"
          >
            <div class="caption" style="opacity: 0.7">Archivos médicos</div>
            <v-btn
              v-for="(doc, index) in person.docs"
              small
              icon
              :key="index"
              @click="openFile(doc)"
              ><v-icon>insert_drive_file</v-icon></v-btn
            >
            <v-icon
              v-if="person.docs && person.docs.length > 0"
              @click="
                $router.push({
                  name: 'resubir',
                  query: {
                    idPerson: person.id,
                    type: 'otros_archivos_medicos',
                  },
                })
              "
              >edit</v-icon
            >
          </div>
        </v-flex>

        <v-flex xs12 v-if="person.alergias">
          <div class="caption" style="opacity: 0.7">Alergias</div>
          <div>{{ person.alergias }}</div>
        </v-flex>
        <v-flex xs12 v-if="person.operaciones">
          <div class="caption" style="opacity: 0.7">Operaciones</div>
          <div>{{ person.operaciones }}</div>
        </v-flex>
        <v-flex xs12 v-if="person.enfermedades">
          <div class="caption" style="opacity: 0.7">Enfermedades</div>
          <div>{{ person.enfermedades }}</div>
        </v-flex>
        <v-flex xs12>
          <div class="caption" style="opacity: 0.7">Archivos</div>
          <div>Vacunas: {{ person.cartilla_vacunacion }}</div>
          <div>S Social: {{ person.seguridad_social }}</div>
          <div>Autorizacion: {{ person.autorizacion }}</div>
          <div>Medico: {{ person.docs }}</div>
        </v-flex>
        <v-flex xs12>
          <div class="caption" style="opacity: 0.7">Covid</div>
          <div>Pasado: {{ person.covid_disease }}</div>
          <div>Vacunación: {{ person.covid_vaccine }}</div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar :timeout="600" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat color="orange" @click.native="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  props: ["person"],
  name: "person-item",
  data: () => ({
    menu: false,
    snackbar: null,
    text: "",
    dialog: false,
  }),
  methods: {
    openFile(file) {
      this.$storage
        .ref()
        .child(file)
        .getDownloadURL()
        .then(function (url) {
          window.open(url);
        })
        .catch(function (error) {
          // Handle any errors
        });
    },
    deleteItem() {
      var vue = this;
      this.dialog = false;
      this.$db
        .collection("forms")
        .doc("inscripciones")
        .collection("people")
        .doc(this.person.id)
        .delete()
        .then(function () {
          vue.snackbar = true;
          vue.text = `Eliminado ${vue.person.id}`;
          // vue.$emit('delete')
        })
        .catch(function (error) {
          console.log(error);
          vue.snackbar = true;
          vue.text = `Error eliminando datos`;
        });
    },
    setStatus(text) {
      var status = this.person.status;
      this.person.status = text;
      var vue = this;
      this.$db
        .collection("forms")
        .doc("inscripciones")
        .collection("people")
        .doc(this.person.id)
        .update({
          status: text,
        })
        .then(function () {
          vue.snackbar = true;
          vue.text = "Cambios guardados";
        })
        .catch(function (error) {
          vue.person.status = status;
          vue.snackbar = true;
          vue.text = "ERROR: No se han guardado los cambios";
          console.error("Error writing document: ", error);
        });
    },
  },
};
</script>

<style scoped>
</style>